export class ApiEndPointsFileManager {
    getFileManagerFolderList = "api/FileManager/GetFileManagerFolders";
    addFolderFileManager = "api/FileManager/AddFileManagerFolder";
    getFileManagerInboxItems = "api/FileManager/GetFileManagerInboxItems";
    FileManagerItemsWithHierarchy = "api/FileManager/FileManagerItemsWithHierarchy";
    addFileManagerFile = "api/FileManager/AddFileManagerFiles";
    uploadChunk = "api/FileManager/UploadChunk";
    GetFileManagerFileDetail = "api/FileManager/GetFileManagerFileDetail";
    GetAllFileManagerTouches = "api/FileManagerTouch/GetAllFileManagerTouches";
    DeleteFileManagerItems = "api/FileManager/DeleteFileManagerItems";
    UpdateDocumentsDetailsByDocumentId = 'api/CoreDocument/UpdateCoreDocumentDetails';
    GetAllFromFolderSharedRole = 'api/Contact/GetAllFromFolderSharedRole';
    GetAllFileFolderSharedRole = 'api/Contact/GetAllFileFolderSharedRole';
    ShareFileFolder ='api/FileManager/ShareFileFolder';    
    GetSharedWithMeFileManager="api/FileManager/GetSharedWithMeFileManager";
    GetAllFileFolderSharedTo="api/FileManager/GetAllFileFolderSharedTo";
    ModifyShareFileFolder="api/FileManager/ModifyShareFileFolder";
    GetSharedWithMeFileManagerWithHierarchy="api/FileManager/GetSharedWithMeFileManagerWithHierarchy";
    getAttachment = 'api/App/DownloadDocument';
    DownloadDocument  = "api/FileManager/DownloadDocument";
    getFoldersList = 'api/Core/GetAllFolders';
    getCoreFeildList = 'api/Core/GetAllFolderFields';
    getAllFolderFields = 'api/Core/GetAllFolderFields';
    searchTransCities = 'api/app/SearchCities';
    searchTransZip = 'api/app/SearchZipCode';
    getStateList = 'api/Orgnization/GetStateValues';
    getAllTagList = 'api/app/GetAllTags';
    getCoreUserDetails = 'api/Core/GetCoreDetail';
    getFileFields = 'api/FileManager/GetFileFields';
    updateDocumentTypeFields = 'api/FileManager/UpdateDocumentTypeFields';
    getDocumentsbyType = "api/FileManager/GetDocumentsbyType";
    updateCoreFieldColumn = 'api/CustomizedGridComponent/UpdateUserGridCustomizationSetting';
    advancedSearch = "api/FileManager/AdvancedSearch";
    GetUserList = 'api/ManageUser/GetUserList';
    getFileAuthors="api/FileManager/GetFileAuthors";
    getFileTypes="api/FileManager/GetFileTypes";
    AddVectorFileID = "api/FileManager/AddVectorFileID";
    GetDocumentCategoriesPCC = 'api/CoreDocument/GetDocumentCategoriesPCC';
    ExtractTextForFileManagerListProcessIcon = "api/FileManager/ExtractTextForFileManagerListProcessIcon";
    attachAIAutomationTemplate="api/FileManager/AttachAIAutomationTemplate";
    getAIAutomationTemplates="api/AIAutomation/GetAIAutomationTemplates";
    aIAutomationRunManuallyForFile="api/AIAutomation/AIAutomationRunManuallyForFile";
    reRunAutomationForAITool="api/AIAutomation/ReRunAutomationForAITool";
    mergePdfFiles="api/FileManager/MergePdfFiles";
    FetchDocAsync = "api/Project/FetchDocFromAzureBlobStorage";
    getMergedFileHistory="api/FileManager/GetMergedFileHistory";
}
